// src/pages/FAQ.jsx

import React from 'react';
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FAQs = [
  {
    question: 'Is MindMapper AI free?',
    answer:
      'Yes, you can use our core features for free, with optional premium add-ons offering advanced features and analysis.',
  },
  {
    question: 'How do I log a dream?',
    answer:
      'From the app home screen, tap "Log Dream", enter your dream details, and let our AI interpret it for deeper insights.',
  },
  {
    question: 'Can I view my dream history?',
    answer: 'Yes, all your logged dreams are stored in a personal Dream Diary for easy access.',
  },
  {
    question: 'How do I create a custom meditation?',
    answer:
      'Go to "Meditation" and tap "Custom Session." Our wizard will guide you through mood, duration, and style preferences.',
  },
  {
    question: 'Is my data secure?',
    answer:
      'We prioritize privacy and use encryption to protect all sensitive data. Your personal dream and meditation logs are never shared.',
  },
];

function FAQ() {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Typography variant="h3" align="center" sx={{ mb: 4 }}>
          Frequently Asked Questions
        </Typography>
        {FAQs.map((item, idx) => (
          <Accordion key={idx} sx={{ mb: 2 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="h6" fontWeight={500}>{item.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body1">{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
}

export default FAQ;
